import { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, fmtDateTime } from "@/lib/api";

export function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const open = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    load();
    nav(n.link || "/");
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="header-notifications-bell" className="relative p-2 rounded-md hover:bg-[#1C2541] transition-colors">
          <Bell className="w-5 h-5 text-slate-300" />
          {data.unread > 0 && <span data-testid="notifications-unread-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center animate-pulse">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0 panel" data-testid="notifications-panel">
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#2E3B61]/60">
          <p className="font-serif text-lg text-white">Notifications</p>
          <button data-testid="notifications-mark-all-read" onClick={() => api.post("/notifications/read-all").then(load)} className="text-xs text-slate-400 hover:text-[var(--brand)] flex items-center gap-1"><CheckCheck className="w-3.5 h-3.5" /> Mark all read</button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 && <p className="text-sm text-slate-500 p-6 text-center">You're all caught up.</p>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => open(n)} data-testid={`notification-item-${n.id}`}
              className={`w-full text-left px-4 py-3 border-b border-[#2E3B61]/40 hover:bg-[#1C2541] transition-colors ${n.read ? "opacity-60" : ""}`}>
              <div className="flex items-start gap-3">
                <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${n.read ? "bg-slate-600" : "bg-[var(--brand)]"}`} />
                <div>
                  <p className="text-sm font-semibold text-slate-100">{n.title}</p>
                  <p className="text-xs text-slate-400 mt-0.5 leading-relaxed">{n.message}</p>
                  <p className="text-[10px] text-slate-500 mt-1">{fmtDateTime(n.created_at)}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
